import {Types} from "../../../type/Types";

export type CampaignPolicyValueObject = {
    id: bigint
    enableMinute: number | null
    disableMinute: number | null
    enableFixedAmount: number | null
    disableFixedAmount: number | null
    currentAmount: number | null
    thresholdValue: number | null
    isAboveThreshold: boolean
    createdAt: Date
    modifiedAt: Date | null
}

export namespace CampaignPolicyValueObject {
    export function construct(o: any): CampaignPolicyValueObject {
        return {
            id: BigInt(o.id),
            enableMinute: Number(o.enableMinute),
            disableMinute: Number(o.disableMinute),
            enableFixedAmount: Number(o.enableFixedAmount),
            disableFixedAmount: Number(o.disableFixedAmount),
            currentAmount: Number(o.currentAmount),
            thresholdValue: Types.asNull(o.thresholdValue,Number),
            isAboveThreshold: Boolean(o.isAboveThreshold),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
        }
    }

    export const description: Record<keyof CampaignPolicyValueObject, string> = {
        id: 'ID',
        enableMinute: '활성화 시각(분)',
        disableMinute: '비활성화 시각(분)',
        enableFixedAmount: '활성화 고정 응답 수',
        disableFixedAmount: '비활성화 고정 응답 수',
        currentAmount: '현재 고정 응답 수',
        thresholdValue: '임계치',
        isAboveThreshold: '임계치 이하 여부', //true -> 임계치 이상, false -> 임계치 이하로 내려감 , false 면 currentAmount = 0 , 즉 소진페이지 연결
        createdAt: '생성 시각',
        modifiedAt: '수정 시각',
    }
}